/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { MetaInterestIndexQueryParams, MetaInterestIndexResponse } from '../types/MetaInterestIndex'

/**
 * GET /meta/interests
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaInterestController.php MetaInterestController::index
 */
export async function metaInterestIndex(
	params?: MetaInterestIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaInterestIndexResponse>> {
	return axiosInstance.get('/meta/interests', { params, ...config })
}
